import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import isEmpty from 'lodash.isempty';
import SelectList from '../SelectList/SelectList';
import { EDIT_IRA_FUNDING_TYPES } from '../../util/constants';
import { ModalHeading } from '../Modal';

const SelectFundingEditFlow = ({
  setEditFundFlow,
  handleNext,
  skipNextStep,
  setModalSize,
  funding,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    setModalSize('md');
  }, [setModalSize]);

  const items = [
    {
      title: t(
        isEmpty(funding) ? 'fundModal.chooseMethod' : 'fundModal.changeMethod',
      ),
      onClick: () => {
        setModalSize('lg');
        setEditFundFlow(EDIT_IRA_FUNDING_TYPES.fundingType);
        handleNext();
      },
      dataCy: 'button-choose-funding-method',
    },
    {
      title: t(
        isEmpty(funding) ? 'fundModal.setDeposit' : 'fundModal.editDeposit',
      ),
      onClick: () => {
        setModalSize('md');
        setEditFundFlow(EDIT_IRA_FUNDING_TYPES.fundingAmount);
        skipNextStep();
      },
      showDivider: false,
      dataCy: 'button-set-funding-amount',
    },
  ];

  return (
    <>
      <ModalHeading mb={16}>
        {t(isEmpty(funding) ? 'fundModal.setupTitle' : 'fundModal.changeTitle')}
      </ModalHeading>
      <SelectList options={items} />
    </>
  );
};

SelectFundingEditFlow.propTypes = {
  setEditFundFlow: PropTypes.func,
  setModalSize: PropTypes.func,
  handleNext: PropTypes.func,
  skipNextStep: PropTypes.func,
  funding: PropTypes.shape({}),
};

export default SelectFundingEditFlow;
